/**
 * Định dạng ngày dùng chung toàn hệ thống. Hiển thị luôn là dd-mm-yyyy;
 * tham số gửi API vẫn là ISO (YYYY-MM-DD) để backend parse không bị nhập nhằng ngày/tháng.
 */
export const DATE_FORMAT = 'DD-MM-YYYY';
export const DATE_TIME_FORMAT = 'DD-MM-YYYY HH:mm';
export const DAY_MONTH_FORMAT = 'DD-MM';
/** Nhãn ngắn có giờ (tem giao hàng, danh sách đơn trong ngày). */
export const DAY_MONTH_TIME_FORMAT = 'DD-MM HH:mm';
export const MONTH_YEAR_FORMAT = 'MM-YYYY';
export const API_DATE_FORMAT = 'YYYY-MM-DD';
